var React = require('react');

function IconPipeline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M635 477.5h72.1c14.2-55.3 64.4-96.1 124.1-96.1 70.8 0 128.1 57.4 128.1 128.1S902 637.6 831.2 637.6c-59.7 0-109.9-40.8-124.1-96.1H635c-14.2 55.3-64.4 96.1-124.1 96.1S401 596.8 386.8 541.5h-71.4c-14.2 55.3-64.4 96.1-124.1 96.1-70.8 0-128.1-57.4-128.1-128.1s57.4-128.1 128.1-128.1c59.7 0 109.9 40.8 124.1 96.1h71.4c14.2-55.3 64.4-96.1 124.1-96.1s109.9 40.9 124.1 96.1zm-443.6 96.1c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1-64.1 28.7-64.1 64.1 28.8 64.1 64.1 64.1zm639.8 0c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1c-35.4 0-64.1 28.7-64.1 64.1s28.7 64.1 64.1 64.1zm-320.2 0c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1-64.1 28.7-64.1 64.1 28.7 64.1 64.1 64.1z"}));
}

IconPipeline.displayName = "IconPipeline";

IconPipeline.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPipeline;

IconPipeline.default = IconPipeline;
